import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Editorial from './screens/Editorial';
import Guide from './screens/Guide';
import PrivacyPolicy from './screens/PrivacyPolicy';
import Terms from './screens/Terms';

const App = () => {
  return (
    <Switch>
      <Route path="/" component={Editorial} exact />
      <Route path="/guides/:slug" component={Guide} exact />
      <Route path="/privacy-policy" component={PrivacyPolicy} exact />
      <Route path="/terms-and-conditions" component={Terms} exact />
    </Switch>
  );
};

export default App;
